import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTruck,
  faUserCheck,
  faComments,
  faBox,
  faChampagneGlasses // alternativo para eventos
} from '@fortawesome/free-solid-svg-icons';

export default function Servicios() {
  return (
    <section className="min-h-screen bg-[#f28c281a] py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-semibold mb-10 text-[#0033A0] text-center">Nuestros Servicios</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

          {/* Servicio: Entrega a domicilio */}
          <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-2xl transition">
            <div className="flex items-center mb-4 text-[#F28C28]">
              <FontAwesomeIcon icon={faTruck} className="text-3xl mr-3" />
              <h3 className="text-xl font-bold">Servicio a Domicilio</h3>
            </div>
            <p className="text-gray-700">
              Recibe tus compras en la puerta de tu casa con solo llamarnos o enviarnos un mensaje por WhatsApp. Ideal para personas mayores o con poco tiempo.
            </p>
          </div>

          {/* Servicio: Atención Personalizada */}
          <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-2xl transition">
            <div className="flex items-center mb-4 text-[#F28C28]">
              <FontAwesomeIcon icon={faUserCheck} className="text-3xl mr-3" />
              <h3 className="text-xl font-bold">Atención Personalizada</h3>
            </div>
            <p className="text-gray-700">
              Nuestro equipo te atiende con calidez, ofreciendo recomendaciones y apoyo en todo momento. ¡Nos gusta servirte como en casa!
            </p>
          </div>

          {/* Servicio: Surtido para eventos */}
          <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-2xl transition">
            <div className="flex items-center mb-4 text-[#F28C28]">
              <FontAwesomeIcon icon={faChampagneGlasses} className="text-3xl mr-3" />
              <h3 className="text-xl font-bold">Surtido para Eventos</h3>
            </div>
            <p className="text-gray-700">
              Tenemos todo lo necesario para tus reuniones: dulces, desechables, bebidas, snacks y mucho más para que tu evento sea un éxito.
            </p>
          </div>

          {/* Servicio: Atención por Encargo */}
          <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-2xl transition">
            <div className="flex items-center mb-4 text-[#F28C28]">
              <FontAwesomeIcon icon={faComments} className="text-3xl mr-3" />
              <h3 className="text-xl font-bold">Atención por Encargo</h3>
            </div>
            <p className="text-gray-700">
              ¿Buscas algo especial? Te conseguimos productos bajo pedido y te avisamos cuando llegan. Siempre nos adaptamos a tus necesidades.
            </p>
          </div>

          {/* Servicio: Carga y ayuda al cliente */}
          <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-2xl transition">
            <div className="flex items-center mb-4 text-[#F28C28]">
              <FontAwesomeIcon icon={faBox} className="text-3xl mr-3" />
              <h3 className="text-xl font-bold">Ayuda con tu Compra</h3>
            </div>
            <p className="text-gray-700">
              Siempre dispuestos a ayudarte a cargar o empacar tus productos. La comodidad del cliente es nuestra prioridad.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
